export const LEVELS = ['beginner', 'intermediate', 'advanced'] as const;
export const GOALS = [
  { id: 'ftp_improvement', label: 'FTP Improvement' },
  { id: 'endurance', label: 'Endurance' },
  { id: 'weight_loss', label: 'Weight Loss' },
  { id: 'sprint_power', label: 'Sprint Power' },
  { id: 'climbing', label: 'Climbing' },
  { id: 'general_fitness', label: 'General Fitness' },
] as const;

// Nutrition-tab enums. These must match the backend validators in
// ``api/routes/profile.py`` (VALID_SEX, VALID_SPORTS,
// VALID_NUTRITION_GOAL). If you change one, change the other.
export const SEX_OPTIONS = [
  { id: 'male', label: 'Male' },
  { id: 'female', label: 'Female' },
  { id: 'other', label: 'Other' },
] as const;
export const SPORT_OPTIONS = [
  { id: 'cycling', label: 'Cycling' },
  { id: 'running', label: 'Running' },
  { id: 'swimming', label: 'Swimming' },
  { id: 'triathlon', label: 'Triathlon' },
  { id: 'duathlon', label: 'Duathlon' },
  { id: 'rowing', label: 'Rowing' },
  { id: 'other', label: 'Other' },
] as const;
export const NUTRITION_GOALS = [
  { id: 'performance', label: 'Performance / fueling training well' },
  { id: 'weight_loss', label: 'Fat loss' },
  { id: 'body_recomp', label: 'Body recomposition' },
  { id: 'muscle_gain', label: 'Lean mass gain' },
  { id: 'maintenance', label: 'Maintain weight' },
  { id: 'race_prep', label: 'Race / event prep' },
] as const;
export const DIETARY_PREFERENCES = [
  { id: 'vegetarian', label: 'Vegetarian' },
  { id: 'vegan', label: 'Vegan' },
  { id: 'pescatarian', label: 'Pescatarian' },
  { id: 'gluten_free', label: 'Gluten-free' },
  { id: 'halal', label: 'Halal' },
  { id: 'kosher', label: 'Kosher' },
  { id: 'dairy_free', label: 'Dairy-free' },
] as const;

/** Parse a comma-separated string into a trimmed non-empty list (or null). */
export function parseCsv(input: string): string[] | null {
  const items = input
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
  return items.length > 0 ? items : null;
}

/** Render a string list back as a comma-separated UI string. */
export function formatCsv(list: string[] | null | undefined): string {
  return list && list.length > 0 ? list.join(', ') : '';
}

/** Add ``id`` to ``list`` if absent, remove it if present. */
export function toggle(list: string[] | null | undefined, id: string): string[] {
  const current = list ?? [];
  return current.includes(id) ? current.filter((x) => x !== id) : [...current, id];
}
